import { ForgotPasswordForm as CoreForgotPasswordForm } from '@/Core/Components/Auth/ForgotPasswordForm'
import { AppConfig } from '@/Ship/Configs/AppConfig'

export const ForgotPasswordForm = () => {
    return <CoreForgotPasswordForm authPageUrl={AppConfig.authPageUrl} />
}
